import { notifications } from "@mantine/notifications";
import { IconAlertTriangle } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import classes from "./HeroTitle.module.css";
import { Container, Title, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";

const DEBUG = false; // Import your DEBUG constant

export function HeroTitle() {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);
  const { t } = useTranslation("translation");

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 768);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (DEBUG) {
      notifications.show({
        id: "websiteStatus",
        title: "This website is in beta",
        message: "Current version: 1.0.0. Last updated on 11.07.2024 at 13:17",
        color: "red",
        icon: <IconAlertTriangle size={"1rem"} />,
      });
    }
  }, []);

  return (
    <div id="home" className={classes.heroWrapper}>
      <div className={classes.heroBackground}>
        <div className={classes.gradientOverlay} />
      </div>
      
      <Container size="xl" className={classes.heroContent}>
        <div className={classes.contentGrid}>
          <div className={classes.titleSection}>
            <Title className={classes.title}>
              {t("title.header")}
            </Title>
          </div>
          
          <div className={classes.descriptionSection}>
            <Text className={classes.description}>
              {t("title.content")}
            </Text>
          </div>
        </div>
      </Container>
    </div>
  );
}